import { DateOperator } from '../interfaces'

export const ZIP_AREA_OPERATOR: { [key: string]: string } = {
  area: 'Bereich',
  exact: 'Exakt',
}

export const ZIP_AREA_OPERATOR_ENTRIES = Object.entries(ZIP_AREA_OPERATOR).map(([k, v]) => ({ id: k as DateOperator, name: v }))
